import React, {Component} from "react";
import {connect} from "react-redux";
import {Box, Button, IconButton, InputAdornment, TextField, Theme, Typography, Grid } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
import {Link} from "react-router-dom";
import * as actions from "../../../../store/actions";
import {Auth, Hub} from "aws-amplify";
import ValidateForm from "../../../../helper/validations";
import CircularProgress from '@material-ui/core/CircularProgress';
import {checkUserAuth} from "./checkUserAuth";
import {CognitoHostedUIIdentityProvider} from "@aws-amplify/auth";
import {Styles} from "@material-ui/core/styles/withStyles";
import Messages from "../../../../helper/messages";
import Backdrop from "@material-ui/core/Backdrop/Backdrop";
import Alert from '@material-ui/lab/Alert';
import ReactHtmlParser, {processNodes} from "react-html-parser";
import Recaptcha from 'react-invisible-recaptcha';
import Config from "../../../../config/config";
import {Helmet} from "react-helmet";
import PrivacyModal from './privacypopup';
import clsx from 'clsx';

const useStyles: Styles<Theme, any, any> = () =>({
  root: {
    backgroundColor: '#6667ab!important',
    width: '100vw',
    height: '100vh'
  },
  actionButtons: {
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
    color: '#fdca42',
    border: '1px solid rgba(253, 202, 66, 0.5)',
    '&:hover': {
			border: '1px solid #fdca42',
      backgroundColor: 'rgba(253, 202, 66, 0.04)'
		},
    padding: '20px'
  },
  textCenter: {
    textAlign: 'center',
    color: '#f2f2f2'
  },
  textRight: {
    textAlign: 'right',
  },
  registerLogo:{
    width:"20vw",
    //height:"41px",
    '@media (max-width: 768px)': {
      width:"60vw"
    },
  },

  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },

  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#6667ab',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/lady_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#fdca42'
  },
  signupText: {
    color: '#f2f2fa'
  },
  error: {},
  passwordInput: {
    width: '100%',
    "& .MuiInputAdornment-positionEnd": {
      margin: "0!important",
    }
  },

  //general
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"90%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"90%",
      maxWidth: "374px",
    },
  },

  //for page 1
  
  
  
  //-----for page 2

  layout2: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: '20px',
    paddingRight: '20px',
    paddingTop:"20px",
    display: 'flex',
    justifyContent: 'center',
    textAlign:"center",
    alignItems: 'center',
    height: '100vh',
    background: '#6667ab',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/lady_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  label: {
    color: '#f2f2fa!important',
    "&$focusedLabel": {
      color: "#fdca42"
    },
    "&$erroredLabel": {
      color: "#fdca42"
    }
  },
  focusedLabel: {
    color: '#fff!important'
  },
  underline: {
    color: '#f2f2fa',
    "&$error:after": {
      borderBottomColor: "#fdca42"
    },
    "&:after": {
      borderBottom: `2px solid #fdca42`
    }
  },

});

interface IProps {
  authUser: any,
  history: any,
  notification: any,
  apolloClient: any,
  loginUser: (client: any, requestData: any, history: any) => void,
  ResendLink: (client: any, request: any) => void,
  classes: any;
  location: any;
}

interface IState {
  email: string,
  password: string,
  loading: boolean,
  googleLoading: boolean,
  appleLoading: boolean,
  passShow: boolean,
  is_rememberMe: string,
  errors: any,
  accountVeryfied: any,
  resendLinkLoading: boolean,
  user: any,
  customState: any,
  errorMsg: string;
  recaptchaError: any;
  loginFailed: boolean;
  [key: string]: any,
  isOpenLoginwithEmail:boolean,
  auto_login: boolean,
}

class Login extends Component<IProps, IState> {
  
  recaptcha: any;
  constructor(props: IProps) {

    super(props);
    this.state = {
      email: "",
      password: "",
      errorMsg: "",
      loading: false,
      googleLoading: false,
      appleLoading: false,
      passShow: true,
      is_rememberMe: 'false',
      errors: {
        email: "Error",
        password: "Error"
      },
      accountVeryfied: false,
      resendLinkLoading: false,
      user: {},
      customState: {},
      recaptchaError: false,
      loginFailed: false,
      privacyData: props.authUser.privacyData,
      isOpenLoginwithEmail:false,
      isRscUrl:false,
      rscText:"",
      auto_login: false
      
    };
  }

  /* Load init data */
  componentDidMount() {
    localStorage.removeItem("rscString");
    Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          this.setState({ user: data });
          break;
        case "signOut":
          this.setState({ user: null });
          break;
        case "customOAuthState":
          this.setState({ customState: data });
          if(data && typeof(data) === "string" && data !==""){
            this.setState({ rscText: data });
          }
          break;
        default:
          break;
      }
    });
    // check user authentication
    if(!localStorage.getItem("user_data")){
      checkUserAuth(this);
    }
    const _this = this
    window.addEventListener('beforeunload', function() {
      if( _this.props.authUser.privacyData ) {
        _this.props.authUser.privacyData = null
      } 
      if( _this.props.authUser.loginDetails ) {
        _this.props.authUser.loginDetails = null
      }
    });
    const queryStringRsc = new URLSearchParams(_this.props.history.location.search).get("rsc")
    if(queryStringRsc){
      this.setState({
        isRscUrl:true,
        rscText:queryStringRsc,
        rscRoute:"/user/register?rsc="+queryStringRsc,
      })
    }
    if (localStorage.getItem("auto_login")) {
      this.setState({
        auto_login: true
      }, () => localStorage.removeItem("auto_login"))
    }
  }

  //  when receive updates from reducers
  UNSAFE_componentWillReceiveProps(props: any) {
    if (props.location.state && props.location.state.email && props.location.state.password) {
      this.setState({
        email: props.location.state.email,
        password: props.location.state.password
      }, () => this.onUserLogin());
      props.location.state.email = null
      props.location.state.password = null
      window.history.replaceState("", "", "/user/login");
      return;
    }
    if (props.authUser.privacyData) {
      this.setState({
        privacyData: props.authUser.privacyData
      }, () => setTimeout(() => {
        this.setState({ auto_login: false })
      }, 2000))
    }
    if (props.authUser.loginDetails) {
      this.setState({
        email:props.authUser.loginDetails.email,
        password:props.authUser.loginDetails.password
      })
      props.authUser.loginDetails = null
    }
    if (props.notification) {
      if (props.notification.message && !props.notification.success) {
        this.setState({
          errorMsg: props.notification.message,
          loginFailed: true,
          auto_login: false
        });
      }
      this.setState({
        loading: false,
        googleLoading: false,
        appleLoading: false
      });
      if (this.state.resendLinkLoading) {
        this.setState({
          accountVeryfied: false,
          resendLinkLoading: false,
          errorMsg: ""
        })
      }
    }
    if (this.props.authUser.accountNotVeryfied) {
      this.setState({ accountVeryfied: props.authUser.accountNotVeryfied });
      this.props.authUser.accountNotVeryfied = false
    } else {
      this.props.authUser.accountNotVeryfied = false
      this.setState({ accountVeryfied: false });
    }
    // don't show the alert when back to this page.
    if (!this.state.email && localStorage.getItem('sso_login') === "false") {
      this.setState({ errorMsg: "" })
    }
  }

  submitLoginForm = (e: any) => {
    e.preventDefault();
    const { loginFailed } = this.state;
    if (loginFailed) {
      this.executeRecaptcha();
    } else {
      this.onUserLogin();
    }
  };

  //execute Recaptcha
  executeRecaptcha = () => {
    this.recaptcha.execute()
  };

  // submit form after validate recaptcha
  validateRecaptcha = () => {
    this.setState({
      recaptchaError:false
    },() => this.onUserLogin())
  };

  // when user try to login
  onUserLogin = () => {
    const requestData = {
      email: this.state.email,
      password: this.state.password
    };
    const { is_rememberMe } = this.state;
    const validateError = ValidateForm.validateLoginForm(requestData);
    this.setState({ errorMsg: "" });
    localStorage.setItem('sso_login', String(false));
    if (!Object.keys(validateError).length) {
      this.setState({ errors: {} });
      if (is_rememberMe) {
        localStorage.setItem('is_rememberMe', this.state.is_rememberMe);
      } else {
        localStorage.removeItem('is_rememberMe');
      }
      this.setState({ loading: true });
      this.props.loginUser(this.props.apolloClient.client, requestData, this.props.history);
    } else {
      this.setState({ errors: validateError })
    }
  };

  // login in with google
  googleLogin = async () => {
    localStorage.setItem('sso_login', String(true));
    this.setState({ googleLoading: true });
    await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google,customState:this.state.rscText });
  };

  // login in with apple
  appleLogin = async () => {
    localStorage.setItem('sso_login', String(true));
    this.setState({ appleLoading: true });
    await Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Apple,customState:this.state.rscText });
  };

  // sign up with email address
  openLoginEmail = async () => {
    this.setState({ isOpenLoginwithEmail: true });
  };

  // when change input fields
  onChange = (event: any) => {
    const value = event.target.value;
    const len = value.length;
    const errors: any = {};
    if (len < 8) {
      errors[event.target.name] = Messages.TENANT.ERROR.PASSWORD.INVALID;
    } else {
      errors[event.target.name] = ""
    }
    this.setState({
      errors: {
        ...this.state.errors,
        [event.target.name]: errors[event.target.name]
      },
      [event.target.name]: event.target.value
    })
  };

  // resend link mail
  resendLink = () => {
    if (this.state.accountVeryfied && this.state.accountVeryfied.username) {
      const request = {
        email: this.state.accountVeryfied.username,
        brand: Config.DEFAULT_SUBBRAND,
      };
      this.setState({ resendLinkLoading: true })
      this.props.ResendLink(this.props.apolloClient.client, request)
    }
  };

  emailValidate = (event: any) => {
    const input = event.target.value;
    const errors: any = {};
    //check email is empty and valid
    const validEmail = /^(([^<>()\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!input) {
      errors[event.target.name] = Messages.TENANT.ERROR.EMAIL.EMPTY;
    } else if (!validEmail.test(input)) {
      errors[event.target.name] = Messages.TENANT.ERROR.EMAIL.INVALID;
    } else {
      errors[event.target.name] = ""
    }

    this.setState({
      errors: {
        ...this.state.errors,
        [event.target.name]: errors[event.target.name]
      },
      [event.target.name]: event.target.value
    })
  };

  togglePasswordVisibility = () => {
    const { passShow } = this.state;
    this.setState({ passShow: !passShow });
  };

  transform = (node: any, index: any) => {
    const { resendLinkLoading } = this.state;
    if (node.type === "tag" && node.name === "span") {
      return (
        <span style={{ cursor: "pointer" }} onClick={() => this.resendLink()} key={index}>
          {resendLinkLoading && <CircularProgress color="inherit" size={10}/>}
          { !resendLinkLoading && processNodes(node.children, this.transform) }
        </span>
      );
    }
  };

  

  render() {
    const { classes, authUser } = this.props;

    const {
      loading,
      googleLoading,
      appleLoading,
      errorMsg,
      passShow,
      errors,
      loginFailed,
      isOpenLoginwithEmail
    } = this.state;


    const signinemailBtn = {color: "#2D2D2D" };

    const options = {
      decodeEntities: true,
      transform: this.transform
    };

console.log(googleLoading);
console.log(appleLoading);
//style={signinemailBtn}
console.log(signinemailBtn);

    return (
      <React.Fragment>
        <Helmet title="Login"/>
        {isOpenLoginwithEmail ?
          <>
            
            <div className={classes.layout2}>
            <Grid container spacing={3}>

              <Grid item xs={12} sm={6}>



              <Box className="">
              
              <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>Awesome. How are you <span className={classes.logoFont}>known</span>?</Typography>
                
                <div className="login-form">
                  <form onSubmit={this.submitLoginForm}>
                    <input type="text" name="email" style={{display:"none"}}/>
                    <TextField
                      InputLabelProps={{
                        classes: {
                          root: classes.label,
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: classes.underline,
                          error: classes.error
                        }
                      }}
                      margin="normal"
                      style={{ width: '100%' }}
                      id="email"
                      label="Enter Email Address"
                      name="email"
                      autoComplete="email"
                      onChange={this.emailValidate}
                    />
                    <input type="text" name="password" style={{display:"none"}}/>
                    <TextField
                      InputLabelProps={{
                        classes: {
                          root: classes.label,
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: classes.underline,
                          error: classes.error
                        },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              className="password-visible-btn"
                              onClick={this.togglePasswordVisibility}
                              aria-label="toggle password visibility"
                            >
                              {
                                !passShow ? <img src='/assets/images/eye-show-visible.svg' alt="show"/>
                                  : <img src='/assets/images/eye-hidden.svg' alt="hidden"/>
                              }
                            </IconButton>
                          </InputAdornment>
                        )
                      }}
                      margin="normal"
                      className={classes.passwordInput}
                      name="password"
                      label="Enter Password"
                      type={passShow ? "password" : "text"}
                      id="password"
                      autoComplete="new-password"
                      onChange={this.onChange}
                      helperText={<span className={classes.textRight} style={{color: '#fff'}}><Link  style={{color: '#cccccc', textDecoration: 'underline'}} to="/user/forgot-password">Forgot My Password</Link></span>}
                    />
                    { errorMsg && <Alert icon={false} style={{width:"100%"}} className="error-alert" severity="error">{ ReactHtmlParser(errorMsg, options) }</Alert> }
                    <Button
                      type="submit"
                      color="secondary" 
                      variant="outlined"
                      size="large"
                      className={classes.actionButtons}
                      disabled={loading || !!(errors && (errors.email || errors.password))}
                    >
                      {loading && <CircularProgress color="inherit" size={20}/>}
                      { !loading && <p style={!!(errors && (errors.email || errors.password)) ? { color: '#707070' } : {}}>Let’s Get Started</p> }
                    </Button>
                  </form>
                  { loginFailed && (
                    <Recaptcha
                      ref={ (ref: any) => this.recaptcha = ref }
                      sitekey= {Config.RECAPTCHA_SITE_KEY}
                      onResolved={this.validateRecaptcha}
                      onError={()=>this.setState({ recaptchaError: Messages.NOTIFICATIONS.ERROR.recaptchaVerificationFail })}
                      onExpired={()=>this.setState({ recaptchaError: Messages.NOTIFICATIONS.ERROR.recaptchaExpired })}
                    />
                  )}
                  {!this.state.isRscUrl &&
                    <Typography variant="subtitle1" className={classes.signupText} >Don’t have an account yet? <Link to={{ pathname: Config.KNOWN_PRICING_URL}} target="_blank" className={classes.signupText} style={{textDecoration: 'underline'}}>Sign up</Link></Typography>
                  }
                  {this.state.isRscUrl &&
                    <Typography variant="subtitle1" className={classes.signupText} >Don’t have an account yet? <Link to={{ pathname: Config.KNOWN_PRICING_URL}} target="_blank" className={classes.signupText} style={{textDecoration: 'underline'}}>Sign up</Link></Typography>
                  }
                </div>
              </Box>

              </Grid>
       
       </Grid>


              <div className="loader">
                <Backdrop open={authUser.screen_loading} >
                  <CircularProgress color="inherit" />
                </Backdrop>
              </div>
              <PrivacyModal docData={this.state.privacyData} email={this.state.email} password={this.state.password} sessionData={this.state.sessionData?this.state.sessionData:{}}/>
            </div>
          </>
        :
          
            <div className={classes.layout}>

<Grid container spacing={3}>

        <Grid item xs={12} sm={6}>
          
        <Box className="">            
              
              {!this.state.auto_login && 
                <>
                  
                  <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)} style={{marginBottom: 30}}>Get <span className={classes.logoFont}>known</span> for making extraordinary content.</Typography>

        
                  
                  <div className="login-form">
                   {/* <Button type="button"
                            color="default" 
                            variant="outlined"
                            size="large"
                            className={classes.actionButtons}
                            startIcon={ !googleLoading && <img src="/assets/images/google.svg" alt="{img}" className="social-icon"/> }
                            disabled={ googleLoading }
                            onClick={() => this.googleLogin()}>
                      {googleLoading && <CircularProgress color="inherit" size={20}/>}
                      { !googleLoading && <p>Continue with Google</p> }
              </Button> 
                    <Button type="button"
                            color="secondary" 
                            variant="outlined"
                            size="large"
                            startIcon={ !appleLoading && <img src="/assets/images/apple.svg" alt="{img}" className="social-icon"/> }
                            className={classes.actionButtons}
                            disabled={ appleLoading }
                            onClick={() => this.appleLogin()}>
                      {appleLoading && <CircularProgress color="inherit" size={20}/>}
                      { !appleLoading && <p>Continue with Apple</p> }
                    </Button> */}
                    <Button
                        type="button"
                        color="secondary" 
                        variant="outlined"
                        size="large"
                        className={classes.actionButtons}
                        startIcon={ !appleLoading && <img src="/assets/images/mail.svg" alt="{img}" className="social-icon"/> }
                        onClick={this.openLoginEmail}
                      >
                        Sign in with email
                    </Button>
                    {!this.state.isRscUrl &&
                      <Typography variant="subtitle1" className={classes.signupText} >Don’t have an account yet? <Link to={{ pathname: Config.KNOWN_PRICING_URL}} target="_blank" className={classes.signupText} style={{textDecoration: 'underline'}}>Sign up</Link></Typography>
                      
                    }
                    {this.state.isRscUrl &&
                      <p className="text-signin" style={{ marginTop:22, color: '#f2f2fa' }}>Don’t have an account yet? <Link to={{ pathname: Config.KNOWN_PRICING_URL}} target="_blank" className={classes.signupText} style={{textDecoration: 'underline'}} >Sign up</Link></p>
                    }
                    { errorMsg && <Alert icon={false} style={{width:"100%"}} className="error-alert" severity="error">{ ReactHtmlParser(errorMsg, options) }</Alert> }
                  </div>
                </>
                }
            </Box>



        </Grid>
       
      </Grid>



            
            <div className="loader">
              <Backdrop open={authUser.screen_loading || this.state.auto_login} >
                <CircularProgress color="inherit" />
              </Backdrop>
            </div>
            <PrivacyModal docData={this.state.privacyData} email={this.state.email} password={this.state.password} sessionData={this.state.sessionData?this.state.sessionData:{}}/>
            </div>
          
        }
        
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => ({
  authUser: state.authUser,
  apolloClient: state.apolloClient,
  notification: state.notification
});

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    loginUser: (client: any, request: any, history: any) => { dispatch(actions.loginUser(client, request, history)); },
    ResendLink: (client: any, request: any) => { dispatch(actions.ResendLink(client, request)); },
    onAuthCheckState: (history: any) => { dispatch(actions.onAuthCheckState(history)); },
    logoutUserSuccess: (user: any) => { dispatch(actions.logoutUserSuccess(user)); },
    onLogout: () => { dispatch(actions.onLogout()); },
    acceptDocument: (client: any,request: any) => { dispatch(actions.acceptDocument(client, request)); },
  };
};

const KnownLoginComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Login));

export {
  KnownLoginComponent
}